var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicateDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.12597 17.417C4.75064 17.417 4.43464 17.2883 4.17797 17.031C3.9213 16.7743 3.79297 16.4583 3.79297 16.083V5.66701H4.87597V16.083C4.87597 16.153 4.9003 16.212 4.94897 16.26C4.99764 16.3087 5.05664 16.333 5.12597 16.333H13.543V17.417H5.12597ZM7.70897 14.833C7.3343 14.833 7.0183 14.7047 6.76097 14.448C6.5043 14.1907 6.37597 13.8747 6.37597 13.5V4.02101C6.37597 3.64567 6.5043 3.32634 6.76097 3.06301C7.0183 2.79901 7.3343 2.66701 7.70897 2.66701H15.189C15.5636 2.66701 15.883 2.79901 16.147 3.06301C16.411 3.32634 16.543 3.64567 16.543 4.02101V13.5C16.543 13.8747 16.411 14.1907 16.147 14.448C15.883 14.7047 15.5636 14.833 15.189 14.833H7.70897ZM7.70897 13.75H15.189C15.2583 13.75 15.3206 13.7257 15.376 13.677C15.4313 13.6283 15.459 13.5693 15.459 13.5V4.02101C15.459 3.95167 15.4313 3.88901 15.376 3.83301C15.3206 3.77767 15.2583 3.75001 15.189 3.75001H7.70897C7.63964 3.75001 7.58064 3.77767 7.53197 3.83301C7.4833 3.88901 7.45897 3.95167 7.45897 4.02101V13.5C7.45897 13.5693 7.4833 13.6283 7.53197 13.677C7.58064 13.7257 7.63964 13.75 7.70897 13.75Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 8,
    width: 5,
    height: 1,
    fill: "#181818"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 6,
    width: 5,
    height: 1,
    transform: "rotate(90 12 6)",
    fill: "#181818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateDraft);
export default __webpack_public_path__ + "static/media/duplicate_draft.cb168e02114e46ec7803f1a628f3adb0.svg";
export { ForwardRef as ReactComponent };